import { store } from '@/store/store'
import axios from 'axios'

const instance = () =>
  axios.create({
    baseURL: 'https://graph.facebook.com/v14.0',
    timeout: 30000
  })

const facebookApi = {
  getAttachments: (messageId) => {
    return instance().get(`/${messageId}/attachments`, {
      params: {
        access_token: store.state.selectedBot.page_access_token
      }
    })
  }
}
export default facebookApi



// WEBPACK FOOTER //
// ./src/api/facebook.js